import { AxiosRequestConfig } from 'axios';
import { Autocomplete, AutocompleteProps } from '@mui/material';

import { Country } from '@/types';
import { useGetCountriesQuery } from '@/services';
import { useAsyncSearch } from '@/hooks';

function SearchCountries<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>({
  config,
  value,
  ...props
}: { config?: AxiosRequestConfig<Country> } & Omit<
  AutocompleteProps<Country, Multiple, DisableClearable, FreeSolo>,
  'options'
>) {
  const asyncGetCountriesQueryProps = useAsyncSearch<Country, Multiple, DisableClearable, FreeSolo>(
    useGetCountriesQuery,
    'id',
    value,
    config,
  );

  return <Autocomplete {...props} {...asyncGetCountriesQueryProps} />;
}

export default SearchCountries;
